import { AnimalTagSearch } from "components/animal/AnimalTagSearch/AnimalTagSearch";
import { Message } from "shared/components/Message";
import { animalMessages } from "domain/animal/animalMessages";
import { FC } from "react";
import { Col } from "reactstrap";

export const AnimalSearch: FC = () => {
    return (
        <main id="main-content" className="container py-4">
            <h1 id="animal-search-heading">
                <Message message={animalMessages.searchPetsPageTitle} />
            </h1>
            <hr aria-hidden="true" />

            <section aria-labelledby="animal-search-heading">
                <Col sm={{ size: 8, offset: 2 }}>
                    <AnimalTagSearch searchAnimalTagLabelToDisplay={false} />
                </Col>
            </section>
        </main>
    );
};
